const produtos_UpNoTreino = [
    {
        img: "creatina_max_titanium.jpg",
        name: "Creatina Max Titanium 150g",
        price: 124.88,
        parcelas: 2,
        type: "pre-treino",
        promo: false,
    },
    {
        img: "creatinatp.jpg",
        name: "Creatina ATP 300g",
        price: 124.88,
        parcelas: 2,
        type: "pre-treino",
        promo: false,
    },
    {
        img: "whey_red.jpg",
        name: "Nutri Whey Protein Refil 1,8kg - IntegralMédica",
        price: 110.49,
        parcelas: 2,
        type: "other",
        promo: true,
    },
    {
        img: "creatina_150g.jpg",
        name: "Creatina 150g - IntegraMédica",
        price: 124.88,
        parcelas: 2,
        type: "other",
        promo: false,
    },
    {
        img: "taurine.jpg",
        name: "Taurine (30caps) - VitaFor",
        price: 49.88,
        parcelas: 2,
        type: "pre-treino",
        promo: true,
    },
    {
        img: "creafort.jpg",
        name: "CreaFort(Creapure) 300g - VitaFor",
        price: 274.90,
        parcelas: 3,
        type: "pre-treino",
        promo: false,
    },
    {
        img: "creatina_blk.jpg",
        name: "Creatina Micronizada 300g - BLK",
        price: 249.99,
        parcelas: 3,
        type: "pre-treino",
        promo: false,
    },
    {
        img: "whey3W.jpg",
        name: "Super Whey 3W 907g - Integral Médica",
        price: 224.88,
        parcelas: 3,
        type: "pos-treino",
        promo: true,
    },

]

export default produtos_UpNoTreino;